import { AxiosResponse } from "axios";
import { RestServiceConnection } from "../restServiceConnection";

const HEADQUARTERS_ENDPOINT = "/headquarter";

export class HeadquarterService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE SEDES
     * @EN GETS THE LIST OF HEADQUARTERS
     */
    // -------------------------------------------------------------------------------------------------------------
    listHeadquarters = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTERS_ENDPOINT + "/list",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UNA SEDE POR SU ID
     * @EN GETS A HEADQUARTER BY ITS ID
     */
    // -------------------------------------------------------------------------------------------------------------
    getHeadquarterById = async (headquarterId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTERS_ENDPOINT + "/get",
            data: { id: headquarterId },    
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES TOGGLEA UNA SEDE
     * @EN TOGGLES A HEADQUARTER
     */
    // -------------------------------------------------------------------------------------------------------------
    toggleHeadquarterStatus = async (headquarterId: string, status: boolean) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTERS_ENDPOINT + "/toggle",
            data: { id: headquarterId, active: status },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UNA SEDE
     * @EN CREATES A HEADQUARTER
     */
    // -------------------------------------------------------------------------------------------------------------
    createHeadquarter = async (headquarter: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTERS_ENDPOINT + "/create",
            data: headquarter,  
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UNA SEDE
     * @EN EDITS A HEADQUARTER
     */
    // -------------------------------------------------------------------------------------------------------------
    editHeadquarter = async (headquarter: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTERS_ENDPOINT + "/edit",
            data: headquarter,  
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UNA SEDE
     * @EN DELETES A HEADQUARTER
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteHeadquarter = async (headquarterId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTERS_ENDPOINT + "/delete",
            data: { id: headquarterId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIAS SUCURSALES
     * @EN DELETES MULTIPLE HEADQUARTERS
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiHeadquarter = async (headquarterIds: string[]) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTERS_ENDPOINT + "/delete-multi",
            data: { 
                ids: headquarterIds,
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA TODAS LAS SEDES
     * @EN DELETES ALL HEADQUARTERS
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteAllHeadquarters = async (companyId: string | null) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTERS_ENDPOINT + "/delete-all",
            data: companyId ? { company: companyId } : {},
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE SEDES PARA UN SELECT
     * @EN GETS THE LIST OF HEADQUARTERS FOR A SELECT
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTERS_ENDPOINT + "/list-select",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE SEDES NO VINCULADAS A RUTAS
     * @EN GETS THE LIST OF HEADQUARTERS NOT LINKED TO ROUTES
     */
    // -------------------------------------------------------------------------------------------------------------
    listUnlinked = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTERS_ENDPOINT + "/unlinked",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES IMPORTA SEDES DESDE UN ARCHIVO EXCEL
     * @EN IMPORTS HEADQUARTERS FROM AN EXCEL FILE
     */
    // -------------------------------------------------------------------------------------------------------------
    importExcel = async (formData: FormData) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: HEADQUARTERS_ENDPOINT + "/import",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}